import { makeOfferUpdateOperation } from '@occc-app/offerHelpers/operations/makeOfferUpdateOperation';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { OfferUpdateInput } from '@occc/graphql';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';

import { CampaignFormValue } from '../../../types';

type OfferCampaignUpdateValues = {
  campaign?: CampaignFormValue;
};

export const getOfferCampaignUpdateOperations = (
  offerId: string,
  values: OfferCampaignUpdateValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  if (!isFieldDirty<OfferCampaignUpdateValues>(dirtyFields, 'campaign')) {
    return [];
  }

  if (!values.campaign?.uuid) {
    return [];
  }

  const campaignUuid = values.campaign.uuid;

  return [
    makeOfferUpdateOperation(offerId, {
      campaignUuid,
    } satisfies Omit<OfferUpdateInput, 'id'>),
  ];
};
